import api from "./api";

export function updatePreference(feature, optOut) {
  return api
    .put(`/unsubscribe/${feature}`, { opt_out: optOut })
    .then((res) => res.data);
}
